import { render } from "./AddToReturnBoxAppCompleteModal.vue?vue&type=template&id=8edcc4b0"
import script from "./AddToReturnBoxAppCompleteModal.vue?vue&type=script&setup=true&lang=js"
export * from "./AddToReturnBoxAppCompleteModal.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "/codebuild/output/src3003388635/src/git-codecommit.ap-northeast-1.amazonaws.com/v1/repos/portal-dev-frontend/vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/pages/components/parts/modal/AddToReturnBoxAppCompleteModal.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "8edcc4b0"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('8edcc4b0', __exports__)) {
    console.log('reload')
    api.reload('8edcc4b0', __exports__)
  }
  
  module.hot.accept("./AddToReturnBoxAppCompleteModal.vue?vue&type=template&id=8edcc4b0", () => {
    console.log('re-render')
    api.rerender('8edcc4b0', render)
  })

}


export default __exports__